exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Canvas_wrapper_1A9sy{position:relative;background-color:#eee;height:100%}@media (min-width:768px){.Canvas_wrapper_1A9sy{padding-bottom:100%;height:auto}}.Canvas_canvas_3Igch{position:absolute;width:100%;height:100%;top:0;left:0}.Canvas_line-0_15PZN{top:35%;left:40%}.Canvas_line-1_22nPU{top:40%;left:40%}.Canvas_line-2_3463M{top:55%;left:40%}.Canvas_line-3_SJO9t{top:20%;left:70%}", ""]);

// exports
exports.locals = {
	"wrapper": "Canvas_wrapper_1A9sy",
	"canvas": "Canvas_canvas_3Igch",
	"line-0": "Canvas_line-0_15PZN",
	"line-1": "Canvas_line-1_22nPU",
	"line-2": "Canvas_line-2_3463M",
	"line-3": "Canvas_line-3_SJO9t"
};